// PricingSection.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MdCheck, MdArrowForward } from "react-icons/md";
import "./CheckInLanding.css";

const basicFeatures = [
    "Up to one check-in per day",
    "Three emergency contacts",
    "Alerts to chosen contacts",
    "Pause anytime",
    "15-minute extensions",
];

const premiumFeatures = [
    "Everything in Basic",
    "Unlimited check-ins per day",
    "SMS verification",
    "Priority alert delivery",
    "Trusted contact circles",
];

const PricingSection = () => {
    return (
        <section className="pricing-section" id="pricing">
            <Container>
                <div className="pricing-heading text-center">
                    <p className="pricing-label">— Pricing</p>

                    <h2 className="pricing-title">
                        Peace of mind, <em>priced honestly.</em>
                    </h2>
                </div>

                <Row className="g-4 justify-content-center align-items-stretch">
                    {/* Basic */}
                    <Col lg={4} md={6}>
                        <div className="price-card basic-card small-card">
                            <div className="price-top">
                                <h3>Free</h3>
                                <span>Starter</span>
                            </div>

                            <p className="price-desc">
                                Essential safety tools to get started.
                            </p>

                            <div className="price-value">
                                <strong>$0.00</strong>
                                <small>/month</small>
                            </div>

                            <p className="price-note pb-4"></p>

                            <ul className="price-list">
                                {basicFeatures.map((item, index) => (
                                    <li key={index}>
                                        <MdCheck />
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>

                            <a href="#" className="price-btn outline-btn">
                                Get Free
                            </a>
                        </div>
                    </Col>

                    {/* Premium */}
                    <Col lg={4}>
                        <div className="price-card premium-card">
                            <span className="popular-badge">Most popular</span>

                            <div className="price-top">
                                <h3>Premium</h3>
                                <span>Always-on</span>
                            </div>

                            <p className="price-desc">
                                Faster verification and unlimited check-ins.
                            </p>

                            <div className="price-value">
                                <strong>$9.99</strong>
                                <small>/month</small>
                            </div>

                            <p className="price-note">or $99/yr — save $20</p>

                            <ul className="price-list dark-list">
                                {premiumFeatures.map((item, index) => (
                                    <li key={index}>
                                        <MdCheck />
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>

                            <a href="#" className="price-btn premium-btn">
                                Get Premium
                                <MdArrowForward size={18} />
                            </a>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default PricingSection;
